namespace Areas.MyWorkflows {
    "use strict";

    var selected: Selected = new Selected();

    export function onUserIDValueChanged(rowData, value) {
        return userValueChanged(selected)(rowData, value);
    }

    export function userLookupEditTemplate(cellElement, cellInfo) {
        return lookupEditTemplate("/MyWorkflows/WorkflowAuthUser/Users", selected)(cellElement, cellInfo);
    }

    export function userLookupCellTemplate(cellElement, cellInfo) {
        return lookupCellTemplate(cellElement, cellInfo);
    }

    export function fillId(e) {
        const dataGrid = $('#WorkflowAuthUserGrid').dxDataGrid('instance');
        const workflowId = dataGrid.option('KeyId');

        e.data.workflowId = workflowId;
        e.data.editRights = false;
        e.data.ccEmail = false;
        e.data.isActive = true;
    }

    export function userDropDownItemTemplate(itemData, itemIndex, itemElement) {
        itemElement.append("<div><span class=\"collookupspan\">" + itemData.displayName + "</span>" + itemData.email + "</div>");
        
    }



  
    




}

